export default __webpack_public_path__ + "static/media/lethargy1.75e8447d.png";